function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Celebrate = function Celebrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M3.923 2.8a.25.25 0 0 0-.346.31L5.69 8.848a.25.25 0 0 0 .403.099l3.322-3.02a.25.25 0 0 0-.057-.409zM2.17 3.63C1.621 2.14 3.176.749 4.594 1.459l5.436 2.718a1.75 1.75 0 0 1 .395 2.86l-3.322 3.02a1.75 1.75 0 0 1-2.82-.69z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M3.923 2.8a.25.25 0 0 0-.346.31L5.69 8.848a.25.25 0 0 0 .403.099l3.322-3.02a.25.25 0 0 0-.057-.409zM2.17 3.63C1.621 2.14 3.176.749 4.594 1.459l5.436 2.718a1.75 1.75 0 0 1 .395 2.86l-3.322 3.02a1.75 1.75 0 0 1-2.82-.69z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M22.174 1.671a.75.75 0 1 0-1.348.658l.5 1.025a.75.75 0 1 0 1.348-.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    d: "M22.174 1.671a.75.75 0 1 0-1.348.658l.5 1.025a.75.75 0 1 0 1.348-.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M10.537 2.524a.75.75 0 0 0-1.074-1.048l-1 1.026A.75.75 0 1 0 9.537 3.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    d: "M10.537 2.524a.75.75 0 0 0-1.074-1.048l-1 1.026A.75.75 0 1 0 9.537 3.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M18.592 4.513a.75.75 0 0 0-1.183-.923l-.404.518A9.7 9.7 0 0 0 13 3.25c-1.584 0-3.08.378-4.403 1.049l1.098.548a1 1 0 0 1 .432.417A8.2 8.2 0 0 1 13 4.75c1.077 0 2.107.207 3.05.582l-.641.822a.75.75 0 0 0 1.182.923l.82-1.05a8.25 8.25 0 1 1-11.95 3.62 1 1 0 0 1-.474-.54l-.39-1.056A9.7 9.7 0 0 0 3.25 13c0 5.385 4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75a9.74 9.74 0 0 0-4.413-8.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    d: "M18.592 4.513a.75.75 0 0 0-1.183-.923l-.404.518A9.7 9.7 0 0 0 13 3.25c-1.584 0-3.08.378-4.403 1.049l1.098.548a1 1 0 0 1 .432.417A8.2 8.2 0 0 1 13 4.75c1.077 0 2.107.207 3.05.582l-.641.822a.75.75 0 0 0 1.182.923l.82-1.05a8.25 8.25 0 1 1-11.95 3.62 1 1 0 0 1-.474-.54l-.39-1.056A9.7 9.7 0 0 0 3.25 13c0 5.385 4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75a9.74 9.74 0 0 0-4.413-8.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M2.629 18.002a.75.75 0 1 0-1.258.817l1 1.539a.75.75 0 0 0 1.258-.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    d: "M2.629 18.002a.75.75 0 1 0-1.258.817l1 1.539a.75.75 0 0 0 1.258-.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M22.537 21.498a.75.75 0 0 0-1.074-1.047l-1 1.026a.75.75 0 1 0 1.074 1.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    d: "M22.537 21.498a.75.75 0 0 0-1.074-1.047l-1 1.026a.75.75 0 1 0 1.074 1.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M10.548 12.436c-.82-.62-1.732-.275-2.096 0a.75.75 0 1 1-.904-1.197c.636-.48 2.324-1.192 3.904 0a.75.75 0 1 1-.904 1.197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    d: "M10.548 12.436c-.82-.62-1.732-.275-2.096 0a.75.75 0 1 1-.904-1.197c.636-.48 2.324-1.192 3.904 0a.75.75 0 1 1-.904 1.197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M15.452 12.436c.364-.275 1.276-.62 2.096 0a.75.75 0 1 0 .904-1.197c-1.58-1.192-3.268-.48-3.904 0a.75.75 0 1 0 .904 1.197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    d: "M15.452 12.436c.364-.275 1.276-.62 2.096 0a.75.75 0 1 0 .904-1.197c-1.58-1.192-3.268-.48-3.904 0a.75.75 0 1 0 .904 1.197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M14.945 16.945A2.75 2.75 0 0 1 10.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75c0 .73-.29 1.429-.805 1.945M13 16.25a1.25 1.25 0 0 0 1-.5h-2q.053.07.116.134c.235.234.553.366.884.366",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M14.945 16.945A2.75 2.75 0 0 1 10.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75c0 .73-.29 1.429-.805 1.945M13 16.25a1.25 1.25 0 0 0 1-.5h-2q.053.07.116.134c.235.234.553.366.884.366",
    clipRule: "evenodd"
  }));
};
export default Celebrate;
Celebrate.displayName = 'Celebrate';